export class TerceraTIFData {
    public date: string;
    public tif: object;

    constructor (date: string, tif: object) {
        this.date = date;
        this.tif = tif;
    }
}
